import { useTranslation } from 'react-i18next';

export interface UnansweredQuestion {
  questionKey: string;
  questionNumber: number;
  pageIndex: number;
}

interface IncompleteSubmissionModalProps {
  show: boolean;
  unansweredQuestions: UnansweredQuestion[];
  totalQuestions: number;
  onConfirm: () => void;
  onGoToUnanswered: () => void;
  onDiscard: () => void;
}

export const IncompleteSubmissionModal = ({
  show,
  unansweredQuestions,
  totalQuestions,
  onConfirm,
  onGoToUnanswered,
  onDiscard
}: IncompleteSubmissionModalProps) => {
  const { t } = useTranslation();

  if (!show) return null;

  const formatQuestionNumbers = (questions: UnansweredQuestion[]): string => {
    const numbers = questions.map((q) => q.questionNumber);
    if (numbers.length === 1) return `${numbers[0]}`;
    const last = numbers[numbers.length - 1];
    const rest = numbers.slice(0, -1);
    return `${rest.join(', ')} ${t('common:validation.questionnaire.questionAnd')} ${last}`;
  };

  const getMessage = (): string => {
    if (unansweredQuestions.length >= totalQuestions) {
      return t('common:validation.questionnaire.incompleteMessageAll');
    }
    if (unansweredQuestions.length === 1) {
      return t('common:validation.questionnaire.incompleteMessageSingle', {
        questions: formatQuestionNumbers(unansweredQuestions)
      });
    }
    return t('common:validation.questionnaire.incompleteMessageMultiple', {
      questions: formatQuestionNumbers(unansweredQuestions)
    });
  };

  return (
    <div className="Overlay">
      <div className="incomplete-modal">
        <p className="incomplete-modal__message">{getMessage()}</p>
        <div className="incomplete-modal__actions">
          <button
            className="incomplete-modal__btn incomplete-modal__btn--no"
            onClick={onGoToUnanswered}>
            {t('common:validation.questionnaire.incompleteNo')}
          </button>
          <button className="incomplete-modal__btn incomplete-modal__btn--yes" onClick={onConfirm}>
            {t('common:validation.questionnaire.incompleteYes')}
          </button>
          <button
            className="incomplete-modal__btn incomplete-modal__btn--discard"
            onClick={onDiscard}>
            {t('common:validation.questionnaire.incompleteDiscard')}
          </button>
        </div>
      </div>
    </div>
  );
};
